import { useState } from "react";


export const usePutFinanceAccountStates = () => {
  const [financeAccountId, setFinanceAccountId] = useState("");
  const [financeId, setFinanceId] = useState("");
  const [accountSid, setAccountSid] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(0);
  const [isAggregate, setIsAggregate] = useState(false);

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
    errorCode: "",
  });

  return {
    financeAccountId,
    setFinanceAccountId,
    financeId,
    setFinanceId,
    accountSid,
    setAccountSid,
    selectedStatus,
    setSelectedStatus,
    isAggregate,
    setIsAggregate,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
